

































import Vue from 'vue'
import {
  DanosEvitablesDTO,
  DanosMadeirablesDTO,
  DanosNonMadeirablesDTO,
  RecognitionDto
} from '@/Application/Expediente'
import AvoidableDamage from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Recognition/AvoidableDamage.vue'
import WoodDamage from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Recognition/WoodDamage.vue'
import NonWoodDamage from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Recognition/NonWoodDamage.vue'

interface Sections {
  danosEvitables: DanosEvitablesDTO | null;
  danosMadeirables: DanosMadeirablesDTO | null;
  danosNonMadeirables: DanosNonMadeirablesDTO | null;
}

export default Vue.extend({
  name: 'Recognition',
  components: {
    AvoidableDamage,
    WoodDamage,
    NonWoodDamage
  },
  props: {
    recognition: {
      type: RecognitionDto || null,
      required: false
    }
  },
  data (): Sections {
    return {
      danosEvitables: null,
      danosMadeirables: null,
      danosNonMadeirables: null
    }
  },
  computed: {
    showEvitables (): boolean {
      return this.hasRecognition && this.recognition.tipoDanos !== '2'
    },
    showMadeirables (): boolean {
      return this.hasRecognition && this.recognition.afeccionDanos !== '2' && this.recognition.tipoDanos !== '1'
    },
    showNonMadeirables (): boolean {
      return this.hasRecognition && this.recognition.afeccionDanos !== '1' && this.recognition.tipoDanos !== '1'
    },
    hasRecognition (): boolean {
      return this.recognition !== null
    },
    dataActa (): string {
      return this.hasRecognition ? this.recognition.dataActa : ''
    },
    horaActa (): string {
      return this.hasRecognition ? this.recognition.horaActa : ''
    },
    numSancionador (): string {
      return this.hasRecognition ? this.recognition.numSancionador : ''
    },
    danos (): string {
      return this.hasRecognition
        ? this.recognition.danos ? this.$t('shared.si').toString() : this.$t('shared.non').toString()
        : ''
    },
    tipoDanos (): string {
      return this.hasRecognition && this.recognition.tipoDanos
        ? this.$t('expediente.recognitionTab.tipoDanos.' + this.recognition.tipoDanos).toString()
        : ''
    },
    observacions (): string {
      return this.hasRecognition
        ? this.recognition.observacions
        : ''
    },
    afeccionDanos (): string {
      return this.hasRecognition && this.recognition.afeccionDanos
        ? this.$t('expediente.recognitionTab.afeccionDanos.' + this.recognition.afeccionDanos).toString()
        : ''
    },
    showDanos (): boolean {
      return this.hasRecognition !== null && this.recognition.danos
    }
  },
  mounted () {
    if (this.recognition !== null) {
      this.danosEvitables = this.recognition.danosEvitables
      this.danosMadeirables = this.recognition.danosMadeirables
      this.danosNonMadeirables = this.recognition.danosNonMadeirables
    }
  }
})
